const DB_NAME = 'MarkedProtocols'
const getDB = ()=>{
  const db = localStorage.getItem(DB_NAME)
  return db ? JSON.parse(localStorage.getItem(DB_NAME)) : new Array
}

export default {

  get (item) {
    const db = Array.from(getDB())
    const find = db.filter(row => row === item )
    return find.length > 0 ? true : false
  },
  save (item) {
    const s = (text)=>{
      const db = Array.from(getDB())
      db.push(text)
      localStorage.setItem(DB_NAME, JSON.stringify(db))
    }
    this.get(item) ? false : s(item)
  }
}
